module.exports = __webpack_public_path__ + "img/Repeat Grid 1.a3621d66.svg";